import DragInputContainer from "./DragInputContainer";

export default DragInputContainer;
